import getText from "../../../../utils/language.js"
import { GlobalContext } from "../../../../utils/globalprovider.js";

import "./appinfos.css"
import React from "react";

import { V2_ConvertSecondToTimeCodeStringMs } from "../../../../utils/timecodev2.js";

class AppInfoElement extends React.Component
{
    render()
    {
        return (
                
                <td width="50%" className="appinfocontent">
                    {this.props.text}&nbsp;:&nbsp;
                    <span className="appinfocontentvalue">
                    {this.props.value}&nbsp;{this.props.unit}
                    </span>
                </td>
                

        )
    }
}

class AppInfo extends React.Component
{
    static contextType = GlobalContext;
    constructor(props)
    {
        super(props)




    }
    render()
    {
        this.titleTrans = getText(6, 0, this.context.language);
        this.titleST = getText(6, 1, this.context.language);

        this.trDuree = getText(6, 2, this.context.language);
        this.trMots = getText(6, 3, this.context.language);
        this.trPhrase = getText(6, 4, this.context.language);
        this.trLisMin = getText(6, 5, this.context.language);
        this.trLisMinCP = getText(6, 6, this.context.language);
        this.trLisMinMM = getText(6, 15, this.context.language);
        this.trLisMinCPMM = getText(6, 16, this.context.language);


        this.stNb = getText(6, 7, this.context.language);
        this.stLisM = getText(6, 8, this.context.language);
        this.stLisMMM = getText(6, 17, this.context.language);
        this.stLenM = getText(6, 9, this.context.language);
        this.stDureeM = getText(6, 10, this.context.language);
        
        this.stDecaleMax  = getText(6, 11, this.context.language);
        this.stDecaleMaxPos  = getText(6, 12, this.context.language);
        this.stDecaleM  = getText(6, 13, this.context.language);

        this.viNbCP = getText(6, 14, this.context.language);



        return(
            <div className ="appinfosfulldiv">
                <div className="appinfostitlediv">
                    <table width="100%">
                        <tr>
                            <td className="appinfostitle" width="50%">
                                {this.titleTrans}
                            </td>
                        </tr>

                    </table>

                </div>
                <div className="appinfoscontentdiv">
                    <table width="100%">
                        <tr>
                            <td width="50%">&nbsp;</td>
                        </tr>        

                        <tr>
                            <AppInfoElement unit="s." text={this.trDuree} value={V2_ConvertSecondToTimeCodeStringMs(this.props.value.trDuree)}/>
                           
                        </tr>        
                        <tr>
                            <AppInfoElement text={this.trMots} value={this.props.value.trMots}/>
                            
                        </tr>        
                        <tr>
                            <AppInfoElement text={this.trPhrase} value={this.props.value.trPhrase}/>
                            
                        </tr>        
                        <tr>
                            <AppInfoElement unit="c/s" text={this.trLisMin} value={this.props.value.trLisMin}/>
                            
                        </tr>        
                        <tr>
                            <AppInfoElement unit="c/s" text={this.trLisMinCP} value={this.props.value.trLisMinCP}/>
                            
                        </tr>
                        <tr>
                            <AppInfoElement unit="m/m" text={this.trLisMinMM} value={this.props.value.trLisMinMM}/>
                            
                        </tr>        
                        <tr>
                            <AppInfoElement unit="m/m" text={this.trLisMinCPMM} value={this.props.value.trLisMinCPMM}/>
                            
                        </tr>
                        <tr>
                            <AppInfoElement unit="" text={this.viNbCP} value={this.props.value.viNbCP}/>
                            
                        </tr>        
                        <tr>
                            <td width="50%">&nbsp;</td>
                        </tr>        

                        <tr>
                            <td className="appinfostitle" width="50%">
                                {this.titleST}
                            </td>
                        </tr>
                        <tr>
                            <td width="50%">&nbsp;</td>
                        </tr>        
                        <tr>
                        <AppInfoElement text={this.stNb} value={this.props.value.stNb}/></tr>
                        <tr><AppInfoElement unit="c/s" text={this.stLisM} value={this.props.value.stLisM}/></tr>
                        <tr><AppInfoElement unit="m/m" text={this.stLisMMM} value={this.props.value.stLisMMM}/></tr>
                        <tr><AppInfoElement unit="c" text={this.stLenM} value={this.props.value.stLenM}/></tr>
                        <tr><AppInfoElement unit="s"text={this.stDureeM} value={this.props.value.stDureeM}/></tr>
                        <tr><AppInfoElement unit="s"text={this.stDecaleMax} value={this.props.value.stDecaleMax}/></tr>
                        <tr><AppInfoElement unit="" text={this.stDecaleMaxPos} value={V2_ConvertSecondToTimeCodeStringMs(this.props.value.stDecaleMaxPos)}/></tr>
                        <tr><AppInfoElement unit="s" text={this.stDecaleM} value={this.props.value.stDecaleM}/></tr>
                    </table>
                </div>
            </div>
        )
    }
}
AppInfo.defaultProps = {
          value:{
              trDuree:0,
              trMots:0,
              trPhrase: 0,
              trLisMin: 0,
              trLisMinCP: 0,
              viNbCP: 0,

              stNb: 0,
              stLisM: 0,
              stLenM: 0,
              stDureeM : 0,

              stDecaleMax: 0,
              stDecaleMaxPos: 0,
              stDecaleM: 0,
          },
        }

export default AppInfo
